module.exports = __webpack_public_path__ + "img/7.df81cbd2.jpg";